import React, { useState, useEffect, useContext, useRef } from "react";
import { Button, Col, Row, Modal, ModalBody } from "reactstrap";
import { AuthContext } from "../../context/AuthContext";

function LogoutTimer() {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [countTime, setCountTime] = useState(10);
  const { handleLogout } = useContext(AuthContext);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    //@ts-ignore
    timerRef.current = setTimeout(handleInactive, 14400000); // 4 horas
    //  timerRef.current = setTimeout(handleInactive, 1800000); // 30m
    // timerRef.current = setTimeout(handleInactive, 10000); // 10s
  };

  const handleInactive = () => {
    setShowPopup(true);
  };

  const handleLogoutPopUp = () => {
    cancelLogout();
    handleLogout();
  };

  const handleEvent = () => {
    resetTimer();
  };

  const cancelLogout = () => {
    setShowPopup(false);
    setCountTime(10);
    handleEvent();
  };

  useEffect(() => {
    if (showPopup) {
      const intervalId = setInterval(() => {
        setCountTime((prevTempo) => prevTempo - 1);
      }, 3000);

      return () => clearInterval(intervalId);
    }
  }, [showPopup]);

  useEffect(() => {
    if (showPopup && countTime === 0) {
      handleLogoutPopUp();
    }
  }, [showPopup, countTime]);


  useEffect(() => {
    window.addEventListener('scroll', handleEvent);
    window.addEventListener('click', handleEvent);

    resetTimer();

    return () => {
      window.removeEventListener('scroll', handleEvent);
      window.removeEventListener('click', handleEvent);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);


  return (
    <>
      {showPopup && (
        <Modal style={{ maxWidth: "690px" }} isOpen={showPopup}>
          <ModalBody>
            <Row className="d-flex" style={{ textAlign: "center" }}>
              <Col>
                <p>Você está inativo há 30 minutos e será desconectado da Plataforma</p>
                <p>Você pode clicar em 'Permanecer Conectado' para cancelar</p>
                <p>{countTime}</p>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center mt-2">
              <Col lg="5" md="5" sm="5">
                <Button
                  className="button-classic"
                  type="button"
                  onClick={cancelLogout}
                >
                  Permanecer conectado
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

export default LogoutTimer;
